module.exports = __webpack_public_path__ + "img/values.b180df00.svg";